module.exports = __webpack_public_path__ + "media/images/img_man-884e6a74b347be48c5b40f5d63b6c335.png";